<template>
  <g class="precolored-design" v-if="!anonymousCrossOrigin">
    <g v-if="color_1">
      <image :width="width" :height="height" :xlink:href="color_1"></image>
    </g>
    <g v-if="color_2">
      <image :width="width" :height="height" :xlink:href="color_2"></image>
    </g>
    <g v-if="color_3">
      <image :width="width" :height="height" :xlink:href="color_3"></image>
    </g>
    <g v-if="shadow">
      <image :width="width" :height="height" :xlink:href="shadow"></image>
    </g>
  </g>
  <div class="precolored-design-container" v-else>
    <img class="design-image-layer" :src="color_1"/>
    <img class="design-image-layer" :src="color_2"/>
    <img class="design-image-layer" :src="color_3"/>
    <img class="design-image-layer" :src="shadow"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PrecoloredDesign",
  props: {
    precoloredDesign: {
      type: String,
    },
    precoloredDesignShadow: {
      type: String,
    },
    designDimension: {
      type: Object,
    },
    isChromagear: {
      type: Boolean,
    },
    anonymousCrossOrigin: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters("playbook", ["color1", "color2", "color3"]),
    ...mapGetters("project", [
      "getPrecoloredDesignURL",
      "getPrecoloredShadowURL",
    ]),

    color_1() {
      return this.getPrecoloredDesignURL(
        this.color1,
        "c1",
        this.precoloredDesign,
        this.isChromagear
      );
    },

    color_2() {
      return this.getPrecoloredDesignURL(
        this.color2,
        "c2",
        this.precoloredDesign,
        this.isChromagear
      );
    },

    color_3() {
      return this.getPrecoloredDesignURL(
        this.color3,
        "c3",
        this.precoloredDesign,
        this.isChromagear
      );
    },

    shadow() {
      return this.getPrecoloredShadowURL(this.precoloredDesignShadow)
    },

    width() {
      return this.designDimension ? this.designDimension.width : 800;
    },

    height() {
      return this.designDimension ? this.designDimension.height : 1000;
    },
  },
  methods: {
    mappedFlashColorName(colorName) {
      switch (colorName.toLowerCase()) {
        case "texas": {
          return "texas-orange";
        }
        case "columbia": {
          return "columbia-blue";
        }
        case "royal": {
          return "royal-blue";
        }
        default: {
          return colorName.toLowerCase();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.precolored-design-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: end;
  position: relative;
  img.design-image-layer {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    height: auto;
  }
}
</style>